import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface FormHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** @deprecated Кнопка «назад» убрана из шапки; проп сохранён для обратной совместимости вызовов. */
  onBack?: () => void;
  actions?: ReactNode;
  sticky?: boolean;
  icon?: ReactNode;
  titleAddon?: ReactNode;
  iconWrapperClassName?: string;
}

/**
 * Form header with title, description, and optional actions.
 * Кнопка «назад» намеренно не рендерится.
 */
export function FormHeader({
  title,
  description,
  actions,
  sticky = false,
  icon,
  titleAddon,
  iconWrapperClassName,
}: FormHeaderProps) {
  const content = (
    <div className="flex flex-wrap items-center gap-4">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {icon && (
          <div
            className={cn(
              "h-10 w-10 shrink-0 rounded-full bg-primary/10 text-primary flex items-center justify-center",
              iconWrapperClassName
            )}
          >
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
            {titleAddon}
          </div>
          {description && (
            <p className="text-muted-foreground">{description}</p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );

  if (!sticky) {
    return content;
  }

  return (
    <div className="sticky top-0 z-20 -mx-4 lg:-mx-6 bg-background/95 backdrop-blur border-b border-border px-4 py-4 lg:px-6">
      {content}
    </div>
  );
}
